import { get } from 'utils/lodash';
import { getAccountsByKeyword } from 'utils/array';
import { DynoFavouriteCard } from 'components/dyno-template';

export const formatTransferFavourites = (accounts, keyword, handleItemClick) => {
  const filteredAccounts = getAccountsByKeyword(accounts, keyword);

  return filteredAccounts.map(item => {
    const index = get(item, 'index', '');
    const bankName = get(item, 'bankName', '');
    const beneficiary = get(item, 'beneficiary', '');
    const transferDesc = get(item, 'transferDesc', '');
    const accountNumber = get(item, 'accountNumber', '');

    const spanLabel = (
      <DynoFavouriteCard
        mainText={beneficiary}
        subText1={bankName}
        subText2={transferDesc}
        subText3={accountNumber}
        onItemClick={option => handleItemClick({ option, ...item })}
      />
    );

    return { id: index, value: index, label: spanLabel };
  });
};
